<template>
  <ol role="list" class="tw-flex tw-items-center tw-space-x-2">
    <li
      v-for="(breadcrumb, index) in breadcrumbs"
      :key="breadcrumb.title"
      :class="[{ 'tw-cursor-pointer': breadcrumb.onClick }]"
      @click="breadcrumb.onClick && breadcrumb.onClick()"
    >
      <div class="tw-flex tw-items-center">
        <chevron-right-icon class="tw-h-4 tw-w-4 tw-flex-shrink-0 tw-text-gray-300 tw-mr-3" v-if="index" />
        <div :class="['tw-text-xs tw-font-thin tw-text-gray-500', { 'tw-text-primary-500 hover:tw-text-primary-600': breadcrumb.onClick }]">
          {{ breadcrumb.title }}
        </div>
      </div>
    </li>
  </ol>
</template>

<script>
import { ChevronRightIcon } from "@/assets/svgs";

export default {
  components: {
    ChevronRightIcon,
  },
  props: {
    breadcrumbs: Array,
  },
};
</script>
